import styled from '@emotion/styled';
import Container from './Container';

const BodyContainer = styled(Container)`
  min-height: calc(100vh - 38px - 48px);
`;

export default BodyContainer;
